import { push } from 'react-router-redux';

import * as consts from './FeaturedConsts';
import { getFeaturedRequest } from '../helpers/requestUtils';
import * as notFoundActions from '../notFound/NotFoundActions';
import * as featuredActions from '../featured/FeaturedActions';

export const setUrlParams = (agentId) => {
    return dispatch => {
        dispatch({
            type: consts.SET_URL_PARAMS_FEATURED,
            payload: {
                agentId,
            }
        })
    }
}

export const getFeatured = (agentId, listingPerPage) => {

    return dispatch => {
        dispatch({
            type: consts.GET_FEATURED_PENDING
        });

        return getFeaturedRequest(agentId, listingPerPage, 0)
            .then(response => {
                if (!!+response.data.disabled) {
                    dispatch(notFoundActions.redirectToNotFound());
                    dispatch({
                        type: consts.GET_FEATURED_REJECTED,
                        payload: {
                            getFeaturedError: 'Agent is not found'
                        }
                    });
                    return;
                }
            dispatch({
                type: consts.GET_FEATURED_FULFILLED,
                payload: response.data[0]
            });
        }, error => {
            console.log(error);
            dispatch(notFoundActions.redirectToNotFound());
            dispatch({
                type: consts.GET_FEATURED_REJECTED,
                payload: {
                    getFeaturedError: error
                }
            });
        });
    }
}


export const getFeaturedPagination = (agentId, listingPerPage, startFrom) => {

    return dispatch => {
        dispatch({
            type: consts.FEATURED_PAGINATION_PENDING
        });

        return getFeaturedRequest(agentId, listingPerPage, startFrom)
            .then(response => {
                if (!!+response.data.disabled) {
                    console.log(error);
                    dispatch({
                        type: consts.FEATURED_PAGINATION_REJECTED,
                        payload: {
                            getFeaturedError: 'Agent is not found'
                        }
                    });
                    return;
                }
            dispatch({
                type: consts.FEATURED_PAGINATION_FULFILLED,
                payload: response.data[0]
            });
            const list = document.getElementById("listings");
            window.scroll({
                top: list.offsetTop,
                left: 0,
                behavior: 'smooth'
            });
        }, error => {
            console.log(error);
            dispatch({
                type: consts.FEATURED_PAGINATION_REJECTED,
                payload: {
                    getFeaturedError: error
                }
            });
        });
    }
}
